import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { User } from '../users/users.types';

export const userLoginApiPath = '/users/login';

export interface PostUserLoginData {
  email: string;
  password: string;
}

export interface PostUserLoginResponse {
  accessToken: string;
}

export const postUserLogin = (data: PostUserLoginData): Promise<AxiosResponse<PostUserLoginResponse & ApiError>> => {
  return instance
    .post<PostUserLoginResponse>(userLoginApiPath, data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const userProfileApiPath = '/profile';

export const fetchUserProfile = (): Promise<AxiosResponse<User & ApiError>> => {
  return instance.get<User>(userProfileApiPath).catch(e => e.response as AxiosError<ApiError> as never);
};

export const postSignOutApiPath = '/users/sign_out';

export const postSignOut = (): Promise<AxiosResponse<PostUserLoginResponse & ApiError>> => {
  return instance
    .post<PostUserLoginResponse>(postSignOutApiPath)
    .catch(e => e.response as AxiosError<ApiError> as never);
};
